import { render } from "./TheManagerUsers.vue?vue&type=template&id=08e313f0"
import script from "./TheManagerUsers.vue?vue&type=script&lang=js"
export * from "./TheManagerUsers.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__